import { render, staticRenderFns } from "./b10.vue?vue&type=template&id=6aa63419&scoped=true"
import script from "./b10.vue?vue&type=script&lang=js"
export * from "./b10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa63419",
  null
  
)

export default component.exports